import { render } from "./ContactBox.vue?vue&type=template&id=bd239396&scoped=true"
import script from "./ContactBox.vue?vue&type=script&lang=js"
export * from "./ContactBox.vue?vue&type=script&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=bd239396&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd239396"]])

export default __exports__